"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
RegisterController.$inject = ['$scope', 'auth', '$window', '$state', 'api', 'notify'];
function RegisterController($scope, auth, $window, $state, api, notify) {
    var token = auth.getToken();
    $scope.data = {};
    $scope.loading = false;
    $scope.message = {
        success: ''
    };
    $scope.exit = function () {
        $window.location.replace('/');
    };
    $scope.save = function () {
        $scope.loading = true;
        api.post('/register', $scope.data)
            .then(function (response) {
            $scope.loading = false;
            notify.success('Zahtev za registraciju je uspešno poslat.');
            $scope.exit();
        }, function (error) {
            $scope.loading = false;
            notify.error(error.data);
        });
    };
    if (!_.isEmpty(token)) {
        $state.go('home');
    }
}
exports.RegisterController = RegisterController;



//////////////////
// WEBPACK FOOTER
// ./scripts/core/register/controllers/RegisterController.js
// module id = 325
// module chunks = 0